module.exports = __webpack_public_path__ + "static/media/prize.11a256a9.png";